import { Field, FieldError, FieldLabel } from "@/ds/shadcn/components/ui/field";
import { MfaCodeInput } from "@/features/common/components/MfaCodeInput";
import { useFieldContext } from "@/lib/form/useAppForm";
import { useMemo, type FC } from "react";

export interface MfaCodeFieldProps {
	ref?: React.Ref<HTMLInputElement>;
	disabled?: boolean;
}

export const MfaCodeField: FC<MfaCodeFieldProps> = ({ref, disabled }) => {
	const field = useFieldContext<string>();

	const error = useMemo(() => {
		if (field.state.meta.errors.length < 1 || !field.state.meta.isBlurred || !field.state.meta.isDirty) {
			return null;
		}

		return field.state.meta.errors[0];
	}, [field.state.meta.errors, field.state.meta.isBlurred, field.state.meta.isDirty]);

	return (
		<Field data-invalid={!!error}>
			<FieldLabel htmlFor={field.name}>6-digit code</FieldLabel>

			<MfaCodeInput
				ref={ref}
				value={field.state.value}
				onChange={field.handleChange}
				disabled={disabled}
				error={!!error} />

			{
				error && <FieldError>{error.message}</FieldError>
			}
		</Field>
	);
};
